import * as types from "./mutation-types";
import router from "@/router";
import Services from "@/services";

export const loading = ({ commit }) => {
  commit(types.LOADING);
};

export const loaded = ({ commit }) => {
  commit(types.LOADED);
};

export const login = ({ commit }) => {
  commit(types.LOGIN);
  router.push({ path: "/" });
};

export const logout = ({ commit }) => {
  commit(types.LOGOUT);
  router.push({ path: "/forbidden" });
};

export const downloadLayout = ({ commit }, companyName) => {
  Services.getById("Configuration/GetLayout", companyName)
    .then(response => {
      commit(types.SETLAYOUT, response.data);
    })
    .catch(error => {
      console.log("Error while downloading layout", error);
    });
};

export const setKey = ({ commit }) => {
  commit(types.SETKEY);
};
